/* ==========================================================================
   stools2 — quick view modal (eye on card hover)
   Opens a per-card modal with gallery, price, quantity, add to cart,
   buy it now, view full details. Also drives the quickview quantity stepper.
   ========================================================================== */

(function () {
  function open(modal) {
    // Move the modal to <body> so position:fixed escapes any transformed /
    // overflow:hidden ancestor (slider tracks, scroll-reveal, etc.) that would
    // otherwise trap it and break stacking. Remember origin to restore on close.
    if (modal.parentNode !== document.body) {
      modal._qvHome = modal._qvHome || { parent: modal.parentNode, next: modal.nextSibling };
      document.body.appendChild(modal);
    }
    modal.classList.add('is-open');
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    // focus close for accessibility
    const closeBtn = modal.querySelector('[data-quickview-close]');
    if (closeBtn) closeBtn.focus();
  }

  function close(modal) {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    const opener = e.target.closest('[data-quickview-open]');
    if (opener) {
      e.preventDefault();
      const modal = document.getElementById(opener.getAttribute('data-quickview-open'));
      if (modal) open(modal);
      return;
    }

    if (e.target.closest('[data-quickview-close]')) {
      const modal = e.target.closest('[data-quickview]');
      if (modal) close(modal);
      return;
    }

    // click on the dimmed overlay closes the modal
    if (e.target.matches('.quickview__overlay')) {
      const modal = e.target.closest('[data-quickview]');
      if (modal) close(modal);
      return;
    }

    // gallery thumbnail swap
    const thumb = e.target.closest('[data-qv-thumb]');
    if (thumb) {
      const gallery = thumb.closest('[data-qv-gallery]');
      const main = gallery && gallery.querySelector('[data-qv-main]');
      const full = thumb.getAttribute('data-full');
      if (main && full) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = full; }
      gallery.querySelectorAll('[data-qv-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }

    // quantity stepper (scoped to [data-qty] so it doesn't clash with PDP/featured)
    const step = e.target.closest('[data-qty] [data-qty-minus], [data-qty] [data-qty-plus]');
    if (step) {
      const wrap = step.closest('[data-qty]');
      const input = wrap.querySelector('input[type="number"]');
      if (input) {
        const isPlus = !!step.closest('[data-qty-plus]');
        let v = parseInt(input.value, 10) || 1;
        v = isPlus ? v + 1 : Math.max(1, v - 1);
        input.value = v;
      }
      return;
    }
  });

  // close the modal after add-to-cart / buy-it-now submit
  document.addEventListener('submit', function (e) {
    const modal = e.target.closest('[data-quickview]');
    if (modal) setTimeout(function () { close(modal); }, 60);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const open = document.querySelector('[data-quickview].is-open');
      if (open) close(open);
    }
  });
})();
